import { render, staticRenderFns } from "./updatePartnerCp.vue?vue&type=template&id=3e2c388a"
import script from "./updatePartnerCp.vue?vue&type=script&lang=js"
export * from "./updatePartnerCp.vue?vue&type=script&lang=js"
import style0 from "./updatePartnerCp.vue?vue&type=style&index=0&id=3e2c388a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports